import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderBarComponent } from './header-bar.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [HeaderBarComponent],
  exports: [HeaderBarComponent]
})
export class HeaderBarModule {
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/header-bar/header-bar.module.ts